let characterCounter = 0

export default () => `character_${++characterCounter}`
